var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedins(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_659_131270)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.56543,
    y: 0.227539,
    width: 36.0651,
    height: 36.0651,
    rx: 18.0325,
    fill: "#1C1C1C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8729 11.7959H14.6428C12.8812 11.7959 11.4531 13.224 11.4531 14.9856V22.2156C11.4531 23.9773 12.8812 25.4054 14.6428 25.4054H21.8729C23.6345 25.4054 25.0626 23.9773 25.0626 22.2156V14.9856C25.0626 13.224 23.6345 11.7959 21.8729 11.7959Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8729 11.7959H14.6428C12.8812 11.7959 11.4531 13.224 11.4531 14.9856V22.2156C11.4531 23.9773 12.8812 25.4054 14.6428 25.4054H21.8729C23.6345 25.4054 25.0626 23.9773 25.0626 22.2156V14.9856C25.0626 13.224 23.6345 11.7959 21.8729 11.7959Z",
    fill: "url(#paint0_linear_659_131270)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2733 23.3683H22.8293C22.8857 23.3683 22.9398 23.3459 22.9797 23.3061C23.0196 23.2662 23.042 23.2121 23.042 23.1557L23.0428 19.8681C23.0428 18.1497 22.6725 16.8289 20.6644 16.8289C19.9011 16.8005 19.1812 17.194 18.7928 17.8511C18.7909 17.8543 18.788 17.8568 18.7845 17.8582C18.7811 17.8596 18.7773 17.8598 18.7737 17.8588C18.7701 17.8579 18.7669 17.8558 18.7647 17.8528C18.7624 17.8499 18.7612 17.8463 18.7611 17.8426V17.2002C18.7611 17.1438 18.7387 17.0897 18.6988 17.0498C18.659 17.01 18.6049 16.9876 18.5485 16.9876H17.0718C17.0154 16.9876 16.9613 17.01 16.9214 17.0498C16.8816 17.0897 16.8591 17.1438 16.8591 17.2002V23.1554C16.8591 23.2118 16.8816 23.2659 16.9214 23.3058C16.9613 23.3457 17.0154 23.3681 17.0718 23.3681H18.6277C18.6841 23.3681 18.7382 23.3457 18.7781 23.3058C18.818 23.2659 18.8404 23.2118 18.8404 23.1554V20.2117C18.8404 19.3793 18.9983 18.5732 20.0302 18.5732C21.0475 18.5732 21.0606 19.5257 21.0606 20.2656V23.1557C21.0606 23.2121 21.083 23.2662 21.1229 23.306C21.1628 23.3459 21.2169 23.3683 21.2733 23.3683ZM13.4736 14.9657C13.4736 15.5964 13.9929 16.1154 14.6236 16.1154C15.2542 16.1153 15.7732 15.596 15.7732 14.9654C15.773 14.3348 15.2541 13.8159 14.6234 13.8159C13.9926 13.8159 13.4736 14.3349 13.4736 14.9657ZM13.8436 23.3683H15.4016C15.458 23.3683 15.5121 23.3459 15.552 23.306C15.5918 23.2662 15.6143 23.2121 15.6143 23.1557V17.2002C15.6143 17.1438 15.5918 17.0897 15.552 17.0498C15.5121 17.01 15.458 16.9876 15.4016 16.9876H13.8436C13.7872 16.9876 13.7331 17.01 13.6932 17.0498C13.6533 17.0897 13.6309 17.1438 13.6309 17.2002V23.1557C13.6309 23.2121 13.6533 23.2662 13.6932 23.306C13.7331 23.3459 13.7872 23.3683 13.8436 23.3683Z",
    fill: "#1C1C1C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_659_131270",
    x: -4.43457,
    y: -4.77246,
    width: 46.0654,
    height: 46.0649,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_659_131270"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_659_131270",
    result: "effect2_innerShadow_659_131270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_659_131270",
    x1: 18.2579,
    y1: 9.34619,
    x2: 18.2579,
    y2: 27.5829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedins);
export default __webpack_public_path__ + "static/media/linkedins.ee5a34e1e9d2cfbb326ab013efd98d5d.svg";
export { ForwardRef as ReactComponent };